import { Env } from 'src/app/core/config/config.model';
import { URLS } from 'src/app/core/config/url.config';
import { OcapiApiApiKey, OneMirrorAccessToken } from 'src/app/utils/global-constants';
import { DoorwayElement, type Settings } from 'src/configs/settings/settings.interface';

// Note: OWCC does lookup the environment by the URL.
// For environments PROD as well as for PrePROD this prod.settings gets looked up,
// to make sure that PrePROD behaves exactly the same like PROD.

export const settings: Partial<Settings> = {
  doorwayConfiguration: {
    disabled: [DoorwayElement.SalesLevelType, DoorwayElement.ConfigurationDate]
  },
  apis: {
    backend: {
      baseUrl: URLS.apis.owcc.prodCached
    },
    carl: {
      baseUrl: URLS.apis.carl.prodCached
    },
    deeplinks: {
      baseUrl: URLS.apis.deeplinks.prod
    },
    ocapi: {
      baseUrl: URLS.apis.ocapi.prod,
      apiKey: OcapiApiApiKey.Prod
    },
    omds: {
      accessToken: OneMirrorAccessToken.Prod,
      baseUrl: URLS.apis.omds[Env.Prod],
      relayService: URLS.apis.omdsRelayService[Env.Prod]
    }
  }
};
